import { create } from 'zustand';
const initialFilters = {
    status: 'all',
    type: 'all',
    search: '',
};
export const useAuctionStore = create((set, get) => ({
    // Initial state
    auctions: [],
    pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
    filters: { ...initialFilters },
    isLoading: false,
    error: null,
    currentAuction: null,
    currentSummary: null,
    currentBids: [],
    isConnected: false,
    reconnecting: false,
    outbidAlert: null,
    winAlert: null,
    // Actions
    setAuctions: (auctions, pagination) => set({ auctions, pagination, error: null }),
    setFilters: (filters) => set((state) => ({ filters: { ...state.filters, ...filters } })),
    setLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error }),
    setCurrentAuction: (auction, summary, bids) => set({ currentAuction: auction, currentSummary: summary, currentBids: bids || [] }),
    updateSummary: (partial) => set((state) => ({
        currentSummary: state.currentSummary ? { ...state.currentSummary, ...partial } : null,
    })),
    addRecentBid: (bid) => set((state) => {
        if (!state.currentSummary)
            return {};
        const recentBids = [bid, ...state.currentSummary.recentBids].slice(0, 10);
        return {
            currentSummary: {
                ...state.currentSummary,
                recentBids,
                currentBid: bid.amount,
                currentBidderAnonymousId: bid.anonymousId,
                bidCount: state.currentSummary.bidCount + 1,
            },
        };
    }),
    setConnectionState: (connected, reconnecting = false) => set({ isConnected: connected, reconnecting }),
    setOutbidAlert: (outbidAlert) => set({ outbidAlert }),
    setWinAlert: (winAlert) => set({ winAlert }),
    clearCurrentAuction: () => set({ currentAuction: null, currentSummary: null, currentBids: [] }),
    reset: () => set({
        auctions: [],
        pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
        filters: { ...initialFilters },
        isLoading: false,
        error: null,
        currentAuction: null,
        currentSummary: null,
        currentBids: [],
        isConnected: false,
        reconnecting: false,
        outbidAlert: null,
        winAlert: null,
    }),
}));
